import { RoomDenominationType, RoomReservationBundle } from "./model";
import { BundlePriceType } from "../bundle/EditBundle/types";

export interface BundleDTO {
  active: boolean;
  bookablePrefix: string;
  bookableTickerWithPrefix: string;
  bundleFixedPrice: number;
  bundlePriceType: keyof BundlePriceType;
  description: string;
  extras: string[];
  hasOneTimePromoCodes: boolean;
  name: string;
  order: number;
  promoCodes: any;
  roomDenomination: RoomDenominationType;
  ticker: string;
}

export function fromBundleDTOToRoomReservationBundle(bundle: BundleDTO): RoomReservationBundle {
  return {
    active: bundle.active,
    bundleFixedPrice: bundle.bundleFixedPrice,
    bundlePriceType: bundle.bundlePriceType,
    description: bundle.description,
    extras: bundle.extras,
    hasOneTimePromoCodes: bundle.hasOneTimePromoCodes,
    name: bundle.name,
    order: bundle.order,
    promoCodes: bundle.promoCodes,
    roomDenomination: bundle.roomDenomination,
    ticker: bundle.ticker
  }
}